import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Redirect, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { PhotoShootStatus } from 'apis/mips/types';
import HighFiveHands from 'common/illustrations/HighFiveHands';
import { Typography as T } from 'common/typography';

import { routes } from '../constants/routes';
import usePhotoShootContext from '../hooks/usePhotoShootContext';

const Root = styled.div`
  margin: 0 auto;
  height: 100%;
  max-width: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  text-align: center;
`;

const Header = styled(T.Heading4)`
  margin-block-end: 8px;
  margin-block-start: 32px;
`;

const Description = styled(T.Body2)`
  display: block;
  color: ${cbSemanticCssVars.textSecondary};
  margin: 12px 0 32px;
`;

const SubmitSuccessPage = () => {
  const { venueId, status } = usePhotoShootContext();
  const { search } = useLocation();

  if (status !== PhotoShootStatus.UPLOADED) {
    return <Redirect to={`${routes.index(venueId)}${search}`} />;
  }

  return (
    <Root>
      <Container>
        <HighFiveHands width={300} />
        <Header>
          <FormattedMessage id="photo-shoot.upload-success.header" />
        </Header>
        <Description>
          <FormattedMessage id="photo-shoot.upload-success.description" />
        </Description>
      </Container>
    </Root>
  );
};

export default SubmitSuccessPage;
